import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=4a076590&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=4a076590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a076590",
  null
  
)

export default component.exports